module.exports = __webpack_public_path__ + "static/media/cng-newsletter-article.5140ff05.png";